import { IsUUID } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { UserOwnableInterface } from '../../user/interfaces/user-ownable.interface';

export class InviteUserDto implements UserOwnableInterface {
  @ApiProperty()
  @IsUUID()
  userId!: string;
}
